module.exports = __webpack_public_path__ + "brochure.pdf";